import { render, staticRenderFns } from "./configOptionRoleModal.vue?vue&type=template&id=b24b1380&scoped=true"
import script from "./configOptionRoleModal.vue?vue&type=script&lang=js"
export * from "./configOptionRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24b1380",
  null
  
)

export default component.exports